import { render, staticRenderFns } from "./AddCompanyWiseSubscriptionFeeComponent.vue?vue&type=template&id=0c879f42&"
import script from "./AddCompanyWiseSubscriptionFeeComponent.vue?vue&type=script&lang=js&"
export * from "./AddCompanyWiseSubscriptionFeeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports